
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ar",
  "es",
  "pt",
  "tr",
  "zh",
  "th",
  "vi",
  "in"
]

export const localeLoaders = {
  "en": [{ key: "../language/en.ts", load: () => import("../language/en.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_en_ts" */), cache: true }],
  "ar": [{ key: "../language/ar.ts", load: () => import("../language/ar.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_ar_ts" */), cache: true }],
  "es": [{ key: "../language/es.ts", load: () => import("../language/es.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_es_ts" */), cache: true }],
  "pt": [{ key: "../language/pt.ts", load: () => import("../language/pt.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_pt_ts" */), cache: true }],
  "tr": [{ key: "../language/tr.ts", load: () => import("../language/tr.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_tr_ts" */), cache: true }],
  "zh": [{ key: "../language/zh.ts", load: () => import("../language/zh.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_zh_ts" */), cache: true }],
  "th": [{ key: "../language/th.ts", load: () => import("../language/th.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_th_ts" */), cache: true }],
  "vi": [{ key: "../language/vi.ts", load: () => import("../language/vi.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_vi_ts" */), cache: true }],
  "in": [{ key: "../language/in.ts", load: () => import("../language/in.ts" /* webpackChunkName: "locale__data_soft_jenkins_workspace_olamet_client_Pipeline_deploy_language_in_ts" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "iso": "en-US",
      "files": [
        "language/en.ts"
      ]
    },
    {
      "code": "ar",
      "iso": "ar-SA",
      "files": [
        "language/ar.ts"
      ]
    },
    {
      "code": "es",
      "iso": "es-ES",
      "files": [
        "language/es.ts"
      ]
    },
    {
      "code": "pt",
      "iso": "pt-PT",
      "files": [
        "language/pt.ts"
      ]
    },
    {
      "code": "tr",
      "iso": "tr-TR",
      "files": [
        "language/tr.ts"
      ]
    },
    {
      "code": "zh",
      "iso": "zh-CN",
      "files": [
        "language/zh.ts"
      ]
    },
    {
      "code": "th",
      "iso": "th-TH",
      "files": [
        "language/th.ts"
      ]
    },
    {
      "code": "vi",
      "iso": "vi-VN",
      "files": [
        "language/vi.ts"
      ]
    },
    {
      "code": "in",
      "iso": "id-ID",
      "files": [
        "language/in.ts"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "language",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://olamet.beta-h5.wooyavip.com",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en-US",
    "files": [
      {
        "path": "language/en.ts"
      }
    ]
  },
  {
    "code": "ar",
    "iso": "ar-SA",
    "files": [
      {
        "path": "language/ar.ts"
      }
    ]
  },
  {
    "code": "es",
    "iso": "es-ES",
    "files": [
      {
        "path": "language/es.ts"
      }
    ]
  },
  {
    "code": "pt",
    "iso": "pt-PT",
    "files": [
      {
        "path": "language/pt.ts"
      }
    ]
  },
  {
    "code": "tr",
    "iso": "tr-TR",
    "files": [
      {
        "path": "language/tr.ts"
      }
    ]
  },
  {
    "code": "zh",
    "iso": "zh-CN",
    "files": [
      {
        "path": "language/zh.ts"
      }
    ]
  },
  {
    "code": "th",
    "iso": "th-TH",
    "files": [
      {
        "path": "language/th.ts"
      }
    ]
  },
  {
    "code": "vi",
    "iso": "vi-VN",
    "files": [
      {
        "path": "language/vi.ts"
      }
    ]
  },
  {
    "code": "in",
    "iso": "id-ID",
    "files": [
      {
        "path": "language/in.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
